import React from 'react';

export function Download(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.2 18.369C21.2 20.0754 19.8644 21.4698 18.1816 21.564L18 21.569H4C2.29363 21.569 0.899208 20.2335 0.805069 18.5506L0.800003 18.369V14.369C0.800003 13.7063 1.33726 13.169 2 13.169C2.62132 13.169 3.13235 13.6412 3.19381 14.2464L3.2 14.369V18.369C3.2 18.7769 3.50519 19.1135 3.89965 19.1628L4 19.169H18C18.4078 19.169 18.7444 18.8639 18.7938 18.4694L18.8 18.369V14.369C18.8 13.7063 19.3373 13.169 20 13.169C20.6213 13.169 21.1324 13.6412 21.1938 14.2464L21.2 14.369V18.369Z"
          fill="currentColor"
        />
        <path
          d="M9.8 13.7596L6.53095 10.9579L6.42709 10.8782C5.9282 10.5364 5.24145 10.6185 4.83889 11.0881C4.40759 11.5913 4.46586 12.3489 4.96905 12.7802L9.56826 16.7223L9.70907 16.8335C10.526 17.4263 11.6536 17.3893 12.4317 16.7223L17.031 12.7802L17.1256 12.6897C17.5397 12.249 17.5637 11.5577 17.1611 11.0881C16.7298 10.5849 15.9722 10.5266 15.4691 10.9579L12.2 13.7596V1.63095L12.1938 1.50826C12.1324 0.903154 11.6213 0.430954 11 0.430954C10.3373 0.430954 9.8 0.968212 9.8 1.63095V13.7596Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
